import React from 'react';
import './text.css'

const Text = ({ input, label, type, icon, unit, disabled, meta: { name, touched, error } }) => {

    return (
	
	<div className={['electroInput', ((error) ? 'error' : ''), ((input.value) ? 'touched' : '')].join(" ")} >
	    <div>
	
		<div className="unit">{unit}</div>
		<label htmlFor={input.name}>
		    {label}
		    
		    <span className="errorLabel"> - {error}</span>
		</label>
		
		<input {...input} disabled={disabled} id={input.name} autoComplete="off" placeholder={label} type={type}  />
	    </div>
	</div>
    )
}

export default Text



// WEBPACK FOOTER //
// ./src/components/Inputs/Text/Text.jsx